import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { DetailFormDataModel } from '../../../config/model/detail-form-data.model';

@Component({
    selector: 'detail-view-header',
    templateUrl: './detail-view-header.component.html',
    styleUrls: ['./detail-view-header.component.scss'],
    standalone: false
})
export class DetailViewHeaderComponent implements OnInit {
  @Input() detailFormDataModel: DetailFormDataModel;
  @Output() closeEvent = new EventEmitter<void>();
  constructor() {}

  ngOnInit() {}

  closeClick(): void {
    this.closeEvent.emit();
  }
}
